module.exports = __webpack_public_path__ + "static/img/phone.90148ebb.png";